import Page from '../../components/util/Page';
import { Box, Card, Tab, Tabs } from '@mui/material';
import { useMemo } from 'react';
import { Button } from '@nps.today/component-library';
import SurveyOrderList from './components/surveyOrder/SurveyOrderList';
import Icon from 'components/icons/Icon';
import { useNavigate, useParams } from 'react-router';
import { TabContext, TabPanel } from '@mui/lab';
import { PATH_DASHBOARD } from 'routes/paths';
import { NoLicenseCard } from './components/NoLicenseCard';
import AccessGuard, { rules } from 'access';
import { useLicense } from 'hooks/useLicense';
import useAuth from 'hooks/useAuth';
import { useTranslator } from 'translation/useTranslator';

export enum OrdersTab {
  SURVEY_ORDERS = 'survey_orders'
}

const Orders = () => {
  const translator = useTranslator();
  const navigate = useNavigate();
  const { tab = OrdersTab.SURVEY_ORDERS } = useParams();
  const { license, licenseLoading } = useLicense();
  const { selectedOrg } = useAuth();

  const TABS = useMemo(() => {
    return [
      {
        value: OrdersTab.SURVEY_ORDERS,
        label: translator.surveyOrders(),
        icon: <Icon type="campaigns" />,
        component: <SurveyOrderList />
      }
    ];
  }, [translator]);

  const onTabChange = (newTab: OrdersTab) => {
    navigate(`${PATH_DASHBOARD.orders.root}/tabs/${newTab}`);
  };

  const onAddOrder = () => {
    navigate(PATH_DASHBOARD.orders.newSurveyOrder);
  };

  return !license && !licenseLoading && selectedOrg?.organizationId ? (
    <Page title={translator.orders()}>
      <NoLicenseCard />
    </Page>
  ) : (
    <Page
      title={translator.orders()}
      stickyHeaderContent={[
        [
          <AccessGuard key="addOrderAccess" rule={rules.order.create}>
            <Button dataTestId="add-order" variant={'contained'} onClick={() => onAddOrder()}>
              {translator.addSurveyOrder()}
            </Button>
          </AccessGuard>
        ]
      ]}
    >
      <Card sx={{ p: 3 }}>
        <TabContext value={tab}>
          <Tabs
            value={tab}
            scrollButtons="auto"
            variant="scrollable"
            allowScrollButtonsMobile
            onChange={(_, value) => onTabChange(value as OrdersTab)}
          >
            {TABS.map((tab) => {
              return (
                <Tab
                  disableRipple
                  key={tab.label}
                  label={tab.label}
                  value={tab.value}
                  icon={tab.icon}
                />
              );
            })}
          </Tabs>
          <Box sx={{ mb: 3 }} />
          {TABS.map((tab) => (
            <TabPanel key={tab.label} value={tab.value}>
              {tab.component}
            </TabPanel>
          ))}
        </TabContext>
      </Card>
    </Page>
  );
};

export default Orders;
